import { render } from "./DataComparisonChart.vue?vue&type=template&id=5aff0ca3&scoped=true"
import script from "./DataComparisonChart.vue?vue&type=script&lang=js"
export * from "./DataComparisonChart.vue?vue&type=script&lang=js"

import "./DataComparisonChart.vue?vue&type=style&index=0&id=5aff0ca3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aff0ca3"]])

export default __exports__